import styled from 'styled-components';
import { font } from '../theme/base/mixins';

export const EmphasizedText = styled.em`
  font-style: italic;
  font-size: inherit;
`;

export const ImportantText = styled.strong`
  font-weight: bold;
`;

export const Hint = styled.span`
  ${font(1.6, 2.1, '300')};
  display: block;
  margin: 20px 0;
`;
